import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { startActionWithPromise } from "../../helpers/saga-promise-helpers";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";

import DataTable from "../../components/DataTable";

import { getUserReportDetailsAction } from "../../redux/reducers/userReportsReducer";

const ReportDetailsModal = props => {

    const { userId, detailType, title, toggleDetailModal } = props;

    const [reportDetails, setReportDetails] = useState([]);

    const dispatch = useDispatch();
    const fetchData = (params) => {
        (async () => {
            try {
                await startActionWithPromise(
                    getUserReportDetailsAction,
                    {
                        params,
                        successCallback: (data) => { setReportDetails(data) },
                        failedCallback: () => { },
                    },
                    dispatch
                );
            } catch { }
        })();
    };

    useEffect(() => {
        const params = {
            userId: userId,
            detailType: detailType,
        };
        fetchData(params);
    }, []);

    const printPlans = (plans) => {
        return plans.map(plan => (<div>{plan}</div>));
    }

    const printBoolean = (boolVal) => {
        if (boolVal)
            return (<span className="text-danger font-weight-bold">Yes</span>);
        return (<span>No</span>);
    }

    const getGridColumns = (detailType) => {

        let columns = [
            {
                dataField: "Detail date",
                text: "Date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '200px' };
                },
            },
        ];

        if (detailType == 'SUBS_PAYMENTS')
            columns = subsPaymentColumns();
        else if (detailType == 'CREDITS_IN')
            columns = creditsInColumns();
        else if (detailType == 'CREDITS_OUT')
            columns = creditsOutColumns();
        else if (detailType == 'ORDER_SUCCEEDED' || detailType == 'ORDER_CANCELED')
            columns = orderColumns();
        else if (detailType == 'REVENUE_TOTAL' || detailType == 'REVENUE_PAID')
            columns = revenueColumns();

        return columns;
    }

    const subsPaymentColumns = () => {
        return [
            {
                dataField: "Payment date",
                text: "Payment date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "amount",
                text: "Amount",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => ('$' + row?.amount),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "overdue",
                text: "overdue",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => printBoolean(row?.overdue),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "planNames",
                text: "Plans",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => printPlans(row?.planNames),
                headerStyle: () => {
                    return { width: '200px' };
                },
            },
        ]
    }

    const creditsInColumns = () => {
        return [
            {
                dataField: "Detail date",
                text: "Purchase date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "OrderNo",
                text: "Order #",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.orderNo),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "Bundle",
                text: "Bundle",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.name),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "credits",
                text: "Credits",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.credits),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "amount",
                text: "Amount ($)",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.amount),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },

        ]
    }

    const creditsOutColumns = () => {
        return [
            {
                dataField: "Detail date",
                text: "Spent date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '200px' };
                },
            },
            {
                dataField: "credits",
                text: "Credits",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.credits),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "amount",
                text: "Amount ($)",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.amount),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "name",
                text: "Video / Resource",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.name),
                headerStyle: () => {
                    return { width: 'auto' };
                },
            },
            {
                dataField: "note",
                text: "Note",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.note),
                headerStyle: () => {
                    return { width: 'auto' };
                },
            },
        ]
    }

    const orderColumns = () => {
        return [
            {
                dataField: "detailDate",
                text: "Purchase date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '200px' };
                },
            },
            {
                dataField: "orderCode",
                text: "Order code",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.orderCode),
                headerStyle: () => {
                    return { width: '120px' };
                },
            },
            {
                dataField: "item",
                text: "Order Item",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.item),
                headerStyle: () => {
                    return { width: 'auto' };
                },
            },
            {
                dataField: "type",
                text: "Item type",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.type),
                headerStyle: () => {
                    return { width: '140px' };
                },
            },
            {
                dataField: "amount",
                text: "Amount ($)",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.amount),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "successful",
                text: "Status",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.successful ? "Paid" : "Canceled"),
                headerStyle: () => {
                    return { width: '120px' };
                },
            },
        ]
    }

    const printMonthYear = (yearMonth) => {
        const str = yearMonth.toString();
        const year = str.slice(0, 4);
        const month = str.slice(4, 6);
        return `${month}/${year}`;
    }

    const revenueColumns = () => {
        return [
            {
                dataField: "detailDate",
                text: "Creation date",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.detailTime),
                headerStyle: () => {
                    return { width: '200px' };
                },
            },
            {
                dataField: "yearMonth",
                text: "Revenue month",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => printMonthYear(row?.yearMonth),
                headerStyle: () => {
                    return { width: '120px' };
                },
            },
            {
                dataField: "totalAmount",
                text: "Amount ($)",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.totalAmount),
                headerStyle: () => {
                    return { width: '120px' };
                },
            },
            {
                dataField: "tranffered",
                text: "Transferred",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.transferred ? "Yes" : "No"),
                headerStyle: () => {
                    return { width: '100px' };
                },
            },
            {
                dataField: "transferDate",
                text: "Transferred on",
                sort: false,
                onSort: (field, order) => { },
                formatter: (_, row) => (row?.transferred ? row?.transferDate : ""),
                headerStyle: () => {
                    return { width: '120px' };
                },
            },
        ]
    }


    return (
        <Modal
            isOpen={true}
            centered
            size="xl"
            className="detailModal"
        >
            <ModalHeader><span className="font-weight-bold">{title}</span></ModalHeader>
            <ModalBody className={`pt-0 pb-0`}>
                <Card className="w-100 h-100 mb-0">
                    <CardBody className="pt-0 pb-0 h-100 data-list position-relative">
                        <DataTable
                            keyField="id"
                            data={reportDetails}
                            columns={getGridColumns(detailType)}
                            hideSelectColumn={true}
                        />
                    </CardBody>
                </Card>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={() => toggleDetailModal()}
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
}
export default ReportDetailsModal;